function SocialMedia() {
  return (
    <div className="grid grid-rows-4 grid-flow-col justify-center items-center">
      <a
        href="https://www.mixcloud.com/under-page/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="fa fa-mixcloud" id="mixcloud"></button>
      </a>

      <a
        href="https://soundcloud.com/raversound"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="fa fa-soundcloud" id="soundcloud"></button>
      </a>

      <a
        href="https://www.facebook.com/raversound.UP/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="fa fa-facebook" id="facebook"></button>
      </a>
      {/*<a
        href="https://open.spotify.com/user/226v6jpq26ph7iit4enrg7syy?si=2f9bfb884797465d"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="fa fa-spotify" id="spotify"></button>
      </a>*/}
      <a
        href="https://www.instagram.com/raversound_underpage/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="fa fa-instagram" id="instagram"></button>
      </a>
    </div>
  );
}

export default SocialMedia;
